var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddnewicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.12421 2.29703C10.6971 1.90099 14.3029 1.90099 17.8758 2.29703C19.854 2.51876 21.45 4.07664 21.6821 6.06181C22.106 9.68567 22.106 13.3466 21.6821 16.9704C21.45 18.9556 19.854 20.5135 17.8758 20.7352C14.3029 21.1313 10.6971 21.1313 7.12421 20.7352C5.14597 20.5135 3.54998 18.9556 3.31785 16.9704C2.89405 13.347 2.89405 9.68644 3.31785 6.06297C3.43526 5.09852 3.87493 4.20199 4.56558 3.51867C5.25624 2.83535 6.15741 2.40529 7.12306 2.29818M12.5 5.75C12.7297 5.75 12.95 5.84126 13.1124 6.00369C13.2749 6.16612 13.3661 6.38642 13.3661 6.61613V10.65H17.4C17.6297 10.65 17.85 10.7412 18.0124 10.9037C18.1749 11.0661 18.2661 11.2864 18.2661 11.5161C18.2661 11.7458 18.1749 11.9661 18.0124 12.1286C17.85 12.291 17.6297 12.3823 17.4 12.3823H13.3661V16.4161C13.3661 16.6458 13.2749 16.8661 13.1124 17.0286C12.95 17.191 12.7297 17.2822 12.5 17.2822C12.2703 17.2822 12.05 17.191 11.8876 17.0286C11.7251 16.8661 11.6339 16.6458 11.6339 16.4161V12.3823H7.60001C7.37029 12.3823 7.14999 12.291 6.98756 12.1286C6.82513 11.9661 6.73387 11.7458 6.73387 11.5161C6.73387 11.2864 6.82513 11.0661 6.98756 10.9037C7.14999 10.7412 7.37029 10.65 7.60001 10.65H11.6339V6.61613C11.6339 6.38642 11.7251 6.16612 11.8876 6.00369C12.05 5.84126 12.2703 5.75 12.5 5.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddnewicon);
export default __webpack_public_path__ + "static/media/addnew.icon.2bb187574f4f02f06680c9cce2c0b4ff.svg";
export { ForwardRef as ReactComponent };